module.exports = __webpack_public_path__ + "static/media/icons_Bilan quadrant supérieur.803b49fe.svg";